import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 3,
        title: 'Work',
        link: '/',
        submenu: [
            {
                id: 31,
                title: 'Testimonials',
                link: '/testimonials'
            },
            {
                id: 32,
                title: 'Case Studies',
                link: '/casestudy'
            }
        ]
    },
    {
        id: 4,
        title: 'Services',
        link: '/',
        submenu: [
            {
                id: 41,
                title: 'Industries',
                link: '/',
                subsubmenu:[
                        {
                            id: 411,
                            title: 'AI SEO Agency',
                            link: '/custom-ai-seo-solution',  
                        },
                        {
                            id: 412,
                            title: 'B2B SEO Agency',
                            link: '/b2b-ai-seo',  
                        },
                        {
                            id: 413,
                            title: 'SaaS SEO Agency',
                            link: '/sasaiseo',  
                        }
                ]
            },
            {
                id: 42,
                title: 'Custom AI Solution',
                link: '/'
            },
            {
                id: 43,
                title: 'AI Automation Solution',
                link: '/'
            }
        ]
    },
    {
        id: 6,
        title: 'Insights',
        link: '/',
        submenu: [
            {
                id: 61,
                title: 'Blogs',
                link: '/bloglist'
            },
            {
                id: 62,
                title: 'Guides',
                link: '/guides'
            },
            {
                id: 63,
                title: 'Contact Us',
                link: '/contact'
            },
        ]
    }
]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [openSubId, setOpenSubId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => (
                <ListItem className={item.id === openId ? 'active' : ''} key={mn}>
                    {item.submenu ? (
                    <>
                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                        {item.title}
                        <i
                            className={
                            item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'
                            }
                        ></i>
                        </p>

                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                        <List className="subMenu">
                            {item.submenu.map((submenu, i) => (
                            <ListItem key={i}>
                                {submenu.subsubmenu ? (
                                <>
                                    <p
                                    onClick={() =>
                                        setOpenSubId(
                                        submenu.id === openSubId ? 0 : submenu.id
                                        )
                                    }
                                    >
                                    {submenu.title}
                                    <i
                                        className={
                                        submenu.id === openSubId
                                            ? 'fa fa-angle-up'
                                            : 'fa fa-angle-down'
                                        }
                                    ></i>
                                    </p>

                                    <Collapse
                                    in={submenu.id === openSubId}
                                    timeout="auto"
                                    unmountOnExit
                                    >
                                    <List className="subSubMenu">
                                        {submenu.subsubmenu.map((sub, j) => (
                                        <ListItem key={j}>
                                            <Link
                                            onClick={ClickHandler}
                                            className="active"
                                            to={sub.link}
                                            >
                                            {sub.title}
                                            </Link>
                                        </ListItem>
                                        ))}
                                    </List>
                                    </Collapse>
                                </>
                                ) : (
                                <Link
                                    onClick={ClickHandler}
                                    className="active"
                                    to={submenu.link}
                                >
                                    {submenu.title}
                                </Link>
                                )}
                            </ListItem>
                            ))}
                        </List>
                        </Collapse>
                    </>
                    ) : (
                    <Link className="active" to={item.link}>
                        {item.title}
                    </Link>
                    )}
                </ListItem>
                ))}

        </ul>
    )
}

export default MobileMenu;